import { render } from "./CurrencyJsonGroup.vue?vue&type=template&id=13f96133"
import script from "./CurrencyJsonGroup.vue?vue&type=script&lang=js"
export * from "./CurrencyJsonGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__